export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ12.d39cdef9.mp3";